module.exports = __webpack_public_path__ + "img/jqr.e2f9053a.png";